import { getCombinedAssociationTypeIdFromParts } from 'customer-data-objects/associations/AssociationCategoryTypes';
import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
export const getAssociationAndObjectTypeDefinitions = ({
  objectTypeId,
  httpClient
}) => {
  const fetchObjectTypeDefinitionsPromise = getFrameworkDataSchemasClient({
    httpClient
  }).then(client => client.frameworkTypes.getObjects());
  const fetchAssociationsPromise = getFrameworkDataSchemasClient({
    httpClient
  }).then(client => client.associations.get({
    frameworkTypeIdentifier: objectTypeId
  }));
  return Promise.all([fetchObjectTypeDefinitionsPromise, fetchAssociationsPromise]).then(([objectTypeDefinitions, associationDefs]) => {
    const associationDefinitions = associationDefs.reduce((acc, associationDefinition) => {
      const toObjectTypeDefinition = objectTypeDefinitions.find(objectTypeDefinition => objectTypeDefinition.objectTypeId === associationDefinition.toObjectTypeId);
      // filter out associations with deactivated toObjectTypeDefinitions
      if (toObjectTypeDefinition) {
        acc.push(Object.assign({}, associationDefinition, {
          toObjectTypeDefinition,
          // portalUniqueIdentifier (aka combinedAssociationTypeId) is in the InboundDbAssociations
          // REST response but not in the FDSR response
          portalUniqueIdentifier: getCombinedAssociationTypeIdFromParts(associationDefinition.category, associationDefinition.id)
        }));
      }
      return acc;
    }, []);
    return associationDefinitions;
  });
};